import { render, staticRenderFns } from "./AddProductCategoryComponent.vue?vue&type=template&id=e196b800&scoped=true"
import script from "./AddProductCategoryComponent.vue?vue&type=script&lang=js"
export * from "./AddProductCategoryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e196b800",
  null
  
)

export default component.exports